import { Component } from '@angular/core';

@Component({
  selector: 'app-mobile-pageRedirection',
  templateUrl: './mobile-pageRedirection.component.html',
  styleUrls: ['./mobile-pageRedirection.component.scss']
})
export class mobilePageRedirectionComponent {

}